import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    padding: 16px;
    border-radius: 4px;
    `;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    `;

export const Title = styled.h3``;

export const TitleFeatured = styled.h4`
    display: flex;
    align-items: center;
    gap: 8px;
    
    color: ${(props) => props.theme.colors.primary};
`;

export const Count = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    border-radius: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const Section = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    width: 100%;
`;

export const FeaturedContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    
    border-left: 5px solid ${(props) => props.theme.colors.primary};
    border-radius: 4px;
    
    padding: 16px;
`;

export const ContentInfor = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Infor = styled.span<{ isTitle: boolean }>`
    display: flex;
    align-items: center;
    
    color: ${(props) => props.isTitle ? props.theme.colors.gray.gray_200 : props.theme.colors.gray.gray_800};
    font-size: ${(props) => props.isTitle ? '14px' : '16px'};

    &.sucess{
        color: ${(props) => props.isTitle ? props.theme.colors.gray.gray_200 : props.theme.colors.success};
    }

    &.blue{
        color: ${(props) => props.isTitle ? props.theme.colors.gray.gray_200 : props.theme.colors.blue};
    }

    &.red{
        color: ${(props) => props.isTitle ? props.theme.colors.gray.gray_200 : props.theme.colors.error};
    }
`;

export const Footer = styled.footer``;